import { render, staticRenderFns } from "./tip.vue?vue&type=template&id=1ccb6a62&scoped=true"
import script from "./tip.vue?vue&type=script&lang=js"
export * from "./tip.vue?vue&type=script&lang=js"
import style0 from "./tip.vue?vue&type=style&index=0&id=1ccb6a62&prod&lang=less&scoped=true"
import style1 from "./tip.vue?vue&type=style&index=1&id=1ccb6a62&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccb6a62",
  null
  
)

export default component.exports